import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { FdnsService } from 'src/app/services/fdns.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-prime-file-upload',
  templateUrl: './prime-file-upload.component.html',
  styleUrls: ['./prime-file-upload.component.scss']
})
export class PrimeFileUploadComponent implements OnInit {
  uploadedFile: any;
  @Input()
  fileConfigurations: any;
  @Output()
  fileUploadSuccess = new EventEmitter();
  uploadedDocuments: any = [];
  envPath: string;


  constructor(private fdnsService: FdnsService, private toastr: ToastrService, private confirmationService: ConfirmationService) { }

  ngOnInit(): void {
    this.envPath = environment.docs;
    if (this.fileConfigurations.fdnsVisitId) {
      this.getFdnsDocuments();
    }


  }

  ngOnChanges(e: SimpleChanges) {
    if (e.fileConfigurations && e.fileConfigurations.currentValue) {
      // this.getFdnsDocuments();
    }
  }

  onUpload(event, fileUpload) {
    debugger
    for (let file of event.files) {
      this.uploadedFile = file;
      this.uploadedFile["fileName"] = file.name;
    }
    fileUpload.clear();
    let payload = new FormData();

    payload.append("file", this.uploadedFile, this.uploadedFile.name);
    this.fdnsService.saveFdnsVisitDocuments(this.fileConfigurations.fdnsVisitId, this.fileConfigurations.beneficiaryId, this.fileConfigurations.fileCategoryId, this.fileConfigurations.fileRefCode, payload).subscribe((response: any) => {
      // console.log("response",response);
      this.getFdnsDocuments();

      if (response.status == 200) {
        this.toastr.success(response.message, 'Success');
        this.getFdnsDocuments();
      }
    })

  }

  getFdnsDocuments() {
    let payload: any = {};
    this.fdnsService.saveFdnsVisitDocuments(this.fileConfigurations.fdnsVisitId, this.fileConfigurations.beneficiaryId, this.fileConfigurations.fileCategoryId, this.fileConfigurations.fileRefCode, payload).subscribe((response: any) => {
      // console.log("get response",response);
      if (response.status == 200) {
        this.uploadedDocuments = response.data;

      }
    })

  }

  viewDocument(item) {
    const docPath = item.substring(23);
    window.open(`${environment.docs}${docPath}`, "_blank");
  }

  confirmDelete(docId) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this record?',
      header: 'Delete',
      accept: () => {
        this.deleteDocument(docId);

      },
      reject: () => {

      }
    });
  }

  deleteDocument(docId) {
    this.fdnsService.deleteFdnsVisitDocuments(this.fileConfigurations.fdnsVisitId, docId).subscribe((response) => {
      //console.log("delete response",response)
      if (response.status == 200) {
        this.toastr.success(response.message, 'Success');
        this.getFdnsDocuments();
      }
    })
  }


}
